import { sentryQabConfig } from './sentryConfig';

export const sentryConfigMakeAPayment = {
  ...sentryQabConfig,
  dsn: 'https://8463d485e79e4cc1bddffd128c50d6e9@o207017.ingest.us.sentry.io/4505068860276736',
};
